import styled from "styled-components";

import { largeScreen } from "src/shared/constants/screenSizes";

const xMargin = 20;

export const MobileWebWrapper = styled.div`
  @media screen and (min-width: ${largeScreen + 1}px) {
    display: none;
  }
`;

export const SearchWrapper = styled.div`
  margin-left: -${xMargin}px;
  margin-top: 20px;
  width: calc(100% + ${xMargin * 2}px);
`;
